import Icon from '../../components/Icon';
import Box from '../../components/layout/Box';
import styled from 'styled-components';

const StyledBox = styled(Box)`
  align-items: center;
  padding-left: 8px;
  padding-right: 8px;
  flex-grow: 1;
  flex-shrink: 1;
  outline: none;

  @media (max-width: 768px) {
    border-radius: 999px;
    background-color: #e7e7e7;
    height: 44px;
    margin-left: 8px;
  }
  @media (min-width: 769px) {
    height: 100%;
  }
`;

const SearchInput = ({
  inputRef,
  debounceSearch,
  setInputFocused,
  onSearch,
}) => {
  return (
    <StyledBox
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <Icon name="search-outline" size={24} color="#000000" />

      <input
        onChange={(e) => debounceSearch(e.target.value)}
        onFocus={() => setInputFocused(true)}
        style={{
          background: 'none',
          borderWidth: 0,
          flexGrow: 1,
          flexShrink: 1,
          fontSize: 16,
          zIndex: 10000,
          color: '#000000',
          marginLeft: 4,
          outline: 'none',
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onSearch(e.target.value);
          }
        }}
        type="search"
        ref={inputRef}
        placeholder="Sök kurslitteratur"
      />
    </StyledBox>
  );
};

export default SearchInput;
